import { render, staticRenderFns } from "./KeyCPF.vue?vue&type=template&id=38045043&scoped=true&"
import script from "./KeyCPF.vue?vue&type=script&lang=js&"
export * from "./KeyCPF.vue?vue&type=script&lang=js&"
import style0 from "./KeyCPF.vue?vue&type=style&index=0&id=38045043&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38045043",
  null
  
)

export default component.exports